import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  name: (<div className="text"><u>I</u>tems</div>),
  trigger: 'i',
  children: {
    'room_spawn': {
      name: (<div className="text"><u>S</u>pawn Item/Enemey</div>),
      trigger: 's',
    },
    'room_award': {
      name: (<div className="text">Spawn room clear <u>a</u>ward</div>),
      trigger: 'a',
    },
    'room_restock': {
      name: (<div className="text"><u>R</u>estock shop</div>),
      trigger: 'r'
    }
  }
}

/* ****************************************************************************************************************
 * NOTE: See room.js for shared command definition for "room_spawn"
 ******************************************************************************************************************/

/* ****************************************************************************************************************
 * Spawn an item from the pool that items are pulled from when the current room is cleared.
 ******************************************************************************************************************/
Blockly.Blocks['room_award'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Spawn room clear award')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Spawns an item from the current rooms item pool used when a room is fully cleared of enemies.')
  }
}

Blockly.JSON['room_award'] = (block) => {
  return {
    action: 'room_award',
  }
}

Schema.registerAction('room_award', {
  "if": {
    "properties": {
      "action": {
        "const": "room_award"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});

/* ****************************************************************************************************************
 * Restock the shop
 ******************************************************************************************************************/
Blockly.Blocks['room_restock'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Restock the shop')
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Restocks the shop.')
  }
}

Blockly.JSON['room_restock'] = (block) => {
  return {
    action: 'room_restock',
  }
}

Schema.registerAction('room_restock', {
  "if": {
    "properties": {
      "action": {
        "const": "room_restock"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {},
        "additionalProperties": false
      }
    }
  }
});
